import GModal from "../../design/components/GModal"
import Button from "../../design/Button";
import { useEffect, useState } from "react";
import { formatDate } from "../../../utility-functions";
import { errorIcon } from "../../../utility-functions/assetLoader";
import colors from "../../design/colors";
import styles from "./ManageLicenseModal.module.css";
import { JService } from "../../api-service/ApiService";
import { CustomSelect } from "../../design/components/customComponents";
import GMultiSelect from "../../design/components/GMultiSelect.jsx";

const retainVnOptions = [
  {value: "Keep number", displayValue: "Keep number"},
  {value: "Remove number", displayValue: "Remove number"}
]


const VirtualNumberModal=({visible, handleClose,renewalDate,handleRemoveNumbers})=>{

    const [updateType,setUpdateType]=useState('Keep number')
    const [selectedNumbers,setSelectedNumbers]=useState([])
    const [numbers,setNumbers]=useState([])
    const [info,setInfo]=useState({visible:false,message:''})
    const [freeNumbersCount,setFreeNumbersCount]=useState(0)
    const [totalNumbers, setTotalNumbers] = useState(0);

    const handleUpdateNumbers=()=>{
      handleRemoveNumbers(selectedNumbers)
    }
    const handleCloseModal=()=>{
      setSelectedNumbers([])
      setInfo({visible:false,message:''})
      setUpdateType('Keep number')
      handleClose()
    }

    useEffect(()=>{
        if(!visible) return;
        if(selectedNumbers.length>0){
            setInfo({visible:true,message:<p className="t7 regular-font">You are requesting to remove <span className="medium-font">{selectedNumbers.length}</span> numbers from your account.<br/>
                The changes will take effect from <span className="medium-font">{formatDate(renewalDate)}</span>.<br/>
                You can continue to use the number until then.</p>})
        }else{
            setInfo({visible:true,message:<p className="t7 regular-font">Virtual numbers not included with plan will incur a monthly fee from <span className="medium-font">{formatDate(renewalDate)}</span>.</p>})
        }
    },[selectedNumbers,renewalDate])

    useEffect(()=>{
        if(!visible) return;
        JService.get('/api/v1/auth/virtual-numbers')
        .then((res)=>{
            if(!res?.success ) throw new Error(res?.message || 'Could not retrieve virtual numbers')
            setNumbers(res?.data?.filter(vn=>(!vn.addon && !vn.delete_scheduled)))
            setTotalNumbers(res?.data?.length)
            setFreeNumbersCount(res?.data?.filter(vn=>(!vn.addon))?.length)
        })
        .catch(err=>{
        })
    },[visible])

    return (
        <GModal 
          visible={visible}
          closeModal={handleCloseModal} 
          heading='Keep/remove virtual number'
          bottomButtons={[
            <Button styleOverride={btnStyle} variant='outlined' hierarchy='white' buttonText='Cancel' onClick={handleCloseModal} disabled={false}/>,
            <Button styleOverride={btnStyle} hierarchy='green' buttonText='Update numbers' onClick={handleUpdateNumbers} disabled={!updateType || (updateType==='Remove number' && (!numbers || !numbers.length))}/>
          ]}
          modalStyle={{padding:'32px',width:'560px',marginBottom:'32px'}}
          body={
            <div>
                 <p className="t7">
                    <span className="medium-font">Virtual numbers: </span>
                    <span className="regular-font">{totalNumbers} numbers </span>
                    <span style={{color:colors.nc_gray_800}}>({freeNumbersCount} included with plan)</span>
                </p>
                <p className="t7">
                    <span className="medium-font">Renewal: </span>
                    <span className="regular-font">{formatDate(renewalDate)}</span>
                </p>
                <form style={{margin:'32px 0'}}>
                <div className="select-container" style={{marginBottom:'4px'}}>
                    <CustomSelect
                      label="Keep/remove virtual number"
                      value={updateType}
                      handleChange={(e) => {
                        if(e.target.value==='Keep number')
                          setSelectedNumbers([])
                        setUpdateType(e.target.value)
                      }}
                      options={retainVnOptions}
                    />
                </div>
                    {updateType==='Remove number' && (
                      <GMultiSelect
                        label=""
                        value={selectedNumbers}
                        handleChange={(val) => setSelectedNumbers(val)}
                        handleDeleteChip={(removedValue) => 
                          setSelectedNumbers(prev => {
                            let temp = [...prev];
                            temp = temp.filter(num => num !== removedValue);
                            return temp
                        })}
                        defaultValue="Select numbers"
                        options={numbers.map(num => ({value: num.id, displayValue: num.country_code + " " + num.number}))}
                      />
                    )}
                </form>
                {info?.visible && <div className={styles.warning}><span style={{marginTop:'4px'}}>{errorIcon('#464c48','16.67','16.67')}</span>{info?.message}</div>}
            </div>
         }
         />
    )
}


const btnStyle = {
  height: "36px",
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: "400",
  padding: "10px 16px",
};

export default VirtualNumberModal;
